import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@pg-app/core/services/auth.guard';
import { RegistrationStep2Guard } from '@pg-app/client/services/registration-step2.guard';
import { ChangeMemorableNumberComponent } from '@pg-app/common/change-memorable-number/change-memorable-number.component';
import { ChangePasswordComponent } from '@pg-app/common/change-password/change-password.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./client-dashboard/client-dashboard.module').then(m => m.ClientDashboardModule)
      },
      {
        path: 'send-payment',
        loadChildren: () => import('./send-payment-instruction/send-payment-instruction.module').then(m => m.SendPaymentInstructionModule)
      },
      {
        path: 'register/step-2',
        canActivate: [RegistrationStep2Guard],
        loadChildren: () => import('./client-register-step2/client-register-step2.module').then(m => m.ClientRegisterStep2Module)
      },
      {
        path: 'client-profile',
        loadChildren: () => import('./client-profile/client-profile.module').then(m => m.ClientProfileModule)
      },
      {
        path: 'change-password',
        component: ChangePasswordComponent
      },
      {
        path: 'change-memorable-number',
        component: ChangeMemorableNumberComponent
      },
      {
        path: 'manage-recipient',
        loadChildren: () => import('./manage-recipient/manage-recipient.module').then(m => m.ManageRecipientModule)
      },
      {
        path: 'approved-payers',
        loadChildren: () => import('./approved-payers/approved-payers.module').then(m => m.ApprovedPayersModule)
      },
      {
        path: 'manage-ultimate-remitters',
        loadChildren: () => import('./manage-ultimate-remitters/manage-ultimate-remitters.module').then(m => m.ManageUltimateRemittersModule)
      },
      {
        path: 'payment',
        loadChildren: () => import('./payment/payment.module').then(m => m.PaymentModule)
      },
      {
        path: 'add-drawdown',
        loadChildren: () => import('./outstanding-trade/outstanding-trade.module').then(m => m.OutstandingTradeModule)
      },
      {
        path: 'statement-report',
        loadChildren: () => import('./statement-report/statement-report.module').then(m => m.StatementReportModule)
      },
      {
        path: 'trade-history',
        loadChildren: () => import('./detailed-trade-history/detailed-trade-history.module').then(m => m.DetailedTradeHistoryModule)
      },
      // {
      //   path: 'external-funds',
      //   loadChildren: () => import('./external-funds/external-funds.module').then(m => m.ExternalFundsModule)
      // },
      {
        path: 'user-management',
        loadChildren: () => import('./user-management/user-management.module').then(m => m.UserManagementModule)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClientRoutingModule { }
